import { render, staticRenderFns } from "./SchoolAccount.vue?vue&type=template&id=ba0648e8&scoped=true"
import script from "./SchoolAccount.vue?vue&type=script&lang=js"
export * from "./SchoolAccount.vue?vue&type=script&lang=js"
import style0 from "./SchoolAccount.vue?vue&type=style&index=0&id=ba0648e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0648e8",
  null
  
)

export default component.exports